import Carousel from "./Carousel"

import { Box } from "@mui/material"
import { useEffect } from "react"
import Layout from "./Layout"
import PrimaryButton from "../../shared/buttons/PrimaryButton"
import SecondaryButton from "../../shared/buttons/SecondaryButton"
import useAppStore from "store/app"

const Home = () => {
  const resetState = useAppStore((state) => state.resetState)
  const t = useAppStore((state) => state.translations)
  const content = t?.data?.pages?.home

  useEffect(() => {
    resetState()
  }, [])

  return (
    <Layout>
      <Carousel />
      <Box sx={{ mt: 2 }}>
        <PrimaryButton fullWidth text={content?.registration} href="/registration" />
        <SecondaryButton fullWidth text={content?.login} href="/login" />
      </Box>
    </Layout>
  )
}

export default Home
